import { render, staticRenderFns } from "./DemoDisplay.vue?vue&type=template&id=2687279a&scoped=true&"
import script from "./DemoDisplay.vue?vue&type=script&lang=js&"
export * from "./DemoDisplay.vue?vue&type=script&lang=js&"
import style0 from "./DemoDisplay.vue?vue&type=style&index=0&id=2687279a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687279a",
  null
  
)

export default component.exports